import { zodResolver } from "@hookform/resolvers/zod";
import { Key } from "lucide-react";
import { memo } from "react";
import { useForm } from "react-hook-form";
import z from "zod";

import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "@/common/components/ui";
import { useToast } from "@/common/hooks/useToast";

const resetPasswordSchema = z.object({
  username: z.string().min(1, "Поле обязательно"),
  email: z
    .string()
    .email("Неверный формат email")
    .min(1, "Поле обязательно")
    .max(100, "Не более 100 символов"),
});

type ResetPasswordData = z.infer<typeof resetPasswordSchema>;

export interface ResetPasswordDialogProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
}

export const ResetPasswordDialog = memo<ResetPasswordDialogProps>(({ isOpen, setIsOpen }) => {
  const { toast } = useToast();

  const resetForm = useForm<ResetPasswordData>({
    resolver: zodResolver(resetPasswordSchema),
    defaultValues: {
      username: "",
      email: "",
    },
  });

  const onResetSubmit = async (data: ResetPasswordData) => {
    toast({
      title: "Запрос отправлен",
      description: "Инструкции по восстановлению пароля отправлены на ваш email",
    });

    setIsOpen(false);
    resetForm.reset();
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="link" className="text-sm">
          <Key className="w-4 h-4 mr-1" />
          Забыли пароль?
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Восстановление пароля</DialogTitle>
        </DialogHeader>

        <Form {...resetForm}>
          <form onSubmit={resetForm.handleSubmit(onResetSubmit)} className="space-y-4" noValidate>
            <FormField
              control={resetForm.control}
              name="username"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Логин</FormLabel>
                  <FormControl>
                    <Input placeholder="Введите ваш логин" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={resetForm.control}
              name="email"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Email</FormLabel>
                  <FormControl>
                    <Input type="email" placeholder="Введите ваш email" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <div className="flex justify-end space-x-2">
              <Button type="button" variant="outline" onClick={() => setIsOpen(false)}>
                Отмена
              </Button>
              <Button type="submit" className="btn-primary">
                Отправить
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
});
